<template>
  <section class="purchase-home">

    <el-row :gutter="24">
      <el-col :span="6">
        <div class="fast-search">
          <el-input placeholder="输入编号,按Enter键" v-model="fastSearchData.code" class="input-with-select search-code" @keyup.enter.native="searchNumber">
            <el-select v-model="fastSearchData.type" slot="prepend">
              <el-option v-for="(v, i) in fastSearchList" :label="v" :value="i"  :key="i"></el-option>
            </el-select>
            <!--<el-button slot="append" @click="searchNumber">GO</el-button>-->
          </el-input>
        </div>
        <section class="layout-panel">
          <header>
            <i class="iconfont theme-color">&#xe62f;</i>
            <span>待我审核</span>
          </header>
          <div class="pending">
            <a href="javascript:void(0)" class="pending-qty" @click="morePendingAudit">{{pendingQty}}</a>
          </div>
        </section>
        <section class="layout-panel notice-panel">
          <header>
            <i class="iconfont exception-color">&#xe631;</i>
            <span>公告</span>
          </header>
          <div class="notice">
            <div class="flex-item flex-item-notice" v-for="(item,index) in noticeList" :key="index">
              <div @click="noticeDetail(item)" class="hand right">{{item.title}}<span v-if="item.is_new" class="new-notice">新</span>  </div>
            </div>
          </div>
          <span class="more right" @click="moreNotice">查看更多>></span>
          <div class="clear"></div>
        </section>
        <section class="layout-panel sticky-note">
          <header>
            <i class="iconfont theme-color">&#xe676;</i>
            <span>便利贴</span>
            <a href="javascript:;" class="clear-btn" @click="clearStickyNote">撕贴</a>
          </header>
          <div class="pending">
            <div class="text-content" contenteditable="true" @blur="setstickyNote" tabindex="0" v-html="stickyNote" ref="stickyNote">
            </div>
          </div>
        </section>
      </el-col>
      <el-col :span="18">
        <section class="layout-panel statistic-box">
          <header>
            <i class="iconfont theme-color">&#xe617;</i>
            <span>数据统计</span>
            <div class="right">
              <el-date-picker
                @blur="getPurchaseSaleQty"
                v-model="searchForm.time"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="选择日期"
                end-placeholder="选择日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
          </header>
          <div class="layout-body">
            <chartLine
              id="dataStat"
              :xAxisData="chartDataList.xAxisData"
              :seriesData="chartDataList.seriesData"
              :titles="titles"
              :date="date"
            ></chartLine>
          </div>
        </section>
        <clock></clock>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import purchase from "@/mixins/purchase/index.js";
import chartLine from "@/components/echarts/line/default";
import clock from "@/components/clock/clock";
import base from "@/mixins/base";
export default {
  components: { chartLine, clock },
  mixins: [base],
  data() {
    return {
      pendingQty: 0,
      searchForm: {
        sku: "",
        time: []
      },
      date: [],
      supplier_code: "",
      skuSaleRankingList: [],
      spuSaleRankingList: [],
      titles: ["采购数量", "销售数量"],
      chartDataList: {
        xAxisData: [],
        seriesData: []
      },
      content:'',
      noticeList: [],

      dataList: [], //数据统计
      fastSearchList: ["产品资料","销售合同", "采购合同", "备货通知【销】", "备货通知【仓】", "发货通知【销】", "发货通知【仓】",
        "报关单", "收款通知", "收款认领", "采购入库", "跨公司调拨", "成本信息"],
      fastSearchData: {
        type: 0,
        code: '',
      },
      stickyNote: '',
    };
  },
  created() {
    this.init();
    this.getPurchaseSaleQty();
    this.getSaleQty();
    this.getPengdingQty();
    this.getNotice();
  },
  mounted() {
    this.$nextTick(() => {
      var dom = document.getElementsByClassName('search-code')[0].childNodes;
      dom.forEach(function (v, i) {
        if (v.tagName == 'INPUT') {
          v.focus();
        }
      });
    });
  },
  methods: {
    init() {
      this.searchForm.time = [
        this.$moment().month(this.$moment().month() - 1).format("YYYY-MM-DD"),
        this.$moment().format("YYYY-MM-DD")
      ];
      this.getstickyNote();
    },
    getstickyNote() {
      var stickyNote = localStorage.getItem('stickyNote');
      stickyNote = stickyNote ? stickyNote : '';
      this.stickyNote = stickyNote;
    },
    clearStickyNote() {
      this.stickyNote = '';
      localStorage.setItem('stickyNote', this.stickyNote);
    },
    setstickyNote(){
      this.stickyNote = this.$refs.stickyNote.innerHTML;
      localStorage.setItem('stickyNote', this.stickyNote);
    },
    getPurchaseSaleQty() {
      _api
        .get(
          "/report/purchase-sale/get-purchase-sale-qty-list",
          this.searchForm
        )
        .then(res => {
          if (res.code == 0) {
            this.chartDataList.xAxisData = res.data.category;
            this.chartDataList.seriesData = res.data.series;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    getSaleQty() {
      _api.get("/report/sale-report/get-ranking-list").then(res => {
        if (res.code == 0) {
          this.skuSaleRankingList = res.data.skuRankList;
          this.spuSaleRankingList = res.data.spuRankList;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getPengdingQty() {
      _api.get("/workbench/wait-audit/get-pending-audit-count").then(res => {
        if (res.code == 0) {
          this.pendingQty = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getNotice() {
      _api.get("/base/system-notice/index", {notice_status: 20, page: 1, pageSize: 5}).then(res => {
        if (res.code == 0) {
          this.noticeList = res.data.list;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    morePendingAudit() {
      let routeUrl = this.$router.resolve({
        name: "wait-audit"
      });
      window.parent.open(routeUrl.href, '_blank');
    },
    moreSkuSale() {
      this.$router.push({ path: "/report/sku-order-qty" });
    },
    moreSpuSale() {
      this.$router.push({ path: "/report/spu-order-qty" });
    },
    moreNotice() {
      let routeUrl = this.$router.resolve({name: "system-notice"});
      window.parent.open(routeUrl.href, '_blank');
    },
    noticeDetail(row) {
      let routeUrl = this.$router.resolve({name: "system-notice-detail", query: {id: row.id}});
      window.parent.open(routeUrl.href, '_blank');
    },
    searchNumber() {
      var param = JSON.parse(JSON.stringify(this.fastSearchData));
      if(!param.code) {
        this.$message.error('请输入编号之后再点GO哦！');
        return false;
      }
      param.type = this.fastSearchList[param.type];
      _api.get("/auth/resource/quick-jump-page",param ).then(res => {
        if (res.code == 0) {
          window.open('/#' + res.data.url);
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.purchase-home {
  overflow-x: hidden;
  .el-row {
    margin-bottom: 20px;
  }
  .flex-item .left {
    width: 54px;
    color: #888;
  }
  .flex-item-notice {
    margin-bottom: 0 !important;
  }
  .rank .flex-item .left {
    width: 110px;
  }
  .hand{
    cursor: pointer;
  }
  .layout-panel {
    border: 1px solid #bcbcbc;
    border-radius: 4px;
    padding: 5px 10px;
    box-shadow: 5px 5px #dedede;
    margin-top: 15px;
    .theme-color {
      color: #1296db;
    }
    .exception-color {
      color: #ff9200;
    }
    header {
      height: 42px;
      line-height: 42px;
      border-bottom: 1px solid #bcbcbc;
      .iconfont {
        font-size: 25px;
      }
      font-size: 13px;
      font-weight: 600;
      color: #333;
      span {
        display: inline-block;
        vertical-align: top;
        padding-left: 5px;
      }
    }

    .more {
      color: #3399ff;
      float: right;
      cursor: pointer;
    }
    .clear {
      clear: both;
    }
    .pending,
    .today-abnormal {
      height: 140px;
      line-height: 109px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 0; /* 滚动条宽度为0 */
        height: 0; /* 滚动条高度为0 */
        display: none; /* 滚动条隐藏 */
      }
      .pending-qty {
        font-size: 35px;
        font-weight: 500;
        color: red;
      }
    }
    .pending {
      padding-top: 20px;
      table {
        width: 100%;
        th,
        td {
          padding: 6px;
          text-align: center;
        }
        th {
          color: #333;
        }
        td {
          color: #1296db;
        }
      }
    }
    .today-abnormal {
      padding-top: 20px;
      .flex-item {
        padding-left: 20px;
        .left {
          color: #333;
          font-weight: bold;
        }
      }
    }
  }
  .sku {
    width: 220px;
  }
  .statistic-box {
    margin-top: 20px;
    header {
      position: relative;
      span {
        vertical-align: middle;
      }
      .right {
        position: absolute;
        top: 0;
        right: 0;
        .el-select {
          &:nth-child(2) {
            width: 130px;
          }
        }
      }
    }
    .layout-body {
      height: 450px;
    }
  }
  .order-stat {
    .layout-body {
      height: 80px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none;
      }
      .el-row {
        text-align: center;
        .flex-item {
          line-height: 70px;
          margin-bottom: 0;
        }
        .left {
          font-weight: 600;
          color: #333;
        }
      }
    }
  }
}
.fast-search{
  width: 100%;
  margin: 20px auto 0;

}
.el-input-group{
  box-shadow: 5px 5px #dedede;
  border: 1px solid #bcbcbc;
  border-radius: 3px;
}
.notice-panel .notice{
  min-height: 132px;
}
  .sticky-note{
    .pending{
      padding: 0!important;
    }
  }
  .text-content{
    min-height: calc(100% - 6px);
    text-align: left;
    padding: 3px 5px;
    line-height: 18px;
  }
  .clear-btn{
    float: right;
    font-weight: initial;
    color: red;
  }
</style>

<style lang="scss">
  .fast-search .el-select .el-input{
    width: 145px;
    color: #777;
  }
  .fast-search  .el-input-group__prepend, .fast-search  .el-input-group__append{
    background: #fff;
    border-color: #fff;
    color: #333;
  }
  .fast-search  .el-input-group__prepend{
    padding-right: 10px;
  }
  .fast-search .el-input__inner{
    border-color: #fff;
  }
  .fast-search .el-select{
    margin: -10px -23px -10px -20px;
  }
  .fast-search .el-input__suffix{
    right: 15px;
  }
  .fast-search .el-select .el-input__inner {
    padding-left: 10px;
  }
  .fast-search .search-code>.el-input__inner{
    padding: 0;
  }
  .fast-search  .el-input-group__prepend input, .fast-search  .el-input-group__prepend i{
    color: #333!important;
  }
  .fast-search .el-input__icon{
    line-height: 34px;
  }
  .fast-search .el-input-group__append{
    padding: 0 10px 0 20px;
  }
  .fast-search .el-button--default {
    padding: 12px 10px 12px 5px;
  }


</style>



// WEBPACK FOOTER //
// index.vue?639c1ee7